// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import implementationSupportRequestEntity from './entities/implementation-support-request.json';
import implementationSupportRequestMenu from '../pages/implementation-support-request/menu.json';
import implementationSupportRequestFullForm from '../pages/implementation-support-request/forms/full.json';
import implementationSupportRequestContextForm from '../pages/implementation-support-request/forms/context.json';
import implementationSupportRequestMiniForm from '../pages/implementation-support-request/forms/mini.json';
import implementationSupportRequestLookupForm from '../pages/implementation-support-request/forms/lookup.json';
import implementationSupportRequestTableView from '../pages/implementation-support-request/views/table.json';
import implementationSupportRequestCardsView from '../pages/implementation-support-request/views/cards.json';
import implementationSupportRequestDashboardView from '../pages/implementation-support-request/views/dashboard.json';

/** Тип запису «Запит на підтримку» зі сторінками пакета: меню, форми та подання з pages/implementation-support-request/. */
export const implementationSupportRequestDefinition: IRecordTypeDefinition = {
  ...implementationSupportRequestEntity,
  views: assembleViewSet({
      table: implementationSupportRequestTableView,
      cards: implementationSupportRequestCardsView,
      dashboard: implementationSupportRequestDashboardView,
  }),
  form: implementationSupportRequestFullForm,
  forms: { full: implementationSupportRequestFullForm, context: implementationSupportRequestContextForm, mini: implementationSupportRequestMiniForm, lookup: implementationSupportRequestLookupForm },
  menu: implementationSupportRequestMenu,
} as IRecordTypeDefinition;
